<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{
          $t('school.academic.operation.profile_mgt.parentProfile.pageTitle')
        }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t(
              'school.academic.operation.profile_mgt.parentProfile.pageTitle'
            ),
            href: '/parent-profiles'
          },
          {
            text: $t('edit'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <!-- <ts-card-wrapper> -->
      <form-wizard
        :title="''"
        :subtitle="''"
        finishButtonText="Save"
        color="#348fe2"
        errorColor="red"
        ref="wizard"
        @on-complete="onComplete"
      >
        <tab-content
          :title="
            $t('school.academic.operation.profile_mgt.parentProfile.father')
          "
          icon="fas fa-male"
          :before-change="() => validateStep('father')"
        >
          <father
            ref="father"
            v-model="model"
            :validate="errors"
            :clear="clear"
          />
        </tab-content>
        <tab-content
          :title="
            $t('school.academic.operation.profile_mgt.parentProfile.mother')
          "
          icon="fas fa-female"
          :before-change="() => validateStep('mother')"
        >
          <mother
            ref="mother"
            v-model="model"
            :validate="errors"
            :clear="clear"
          />
        </tab-content>
        <tab-content
          :title="
            $t('school.academic.operation.profile_mgt.parentProfile.address')
          "
          icon="fas fa-map-marker-alt"
          :before-change="saveParentProfile"
        >
          <address-component
            v-model="model"
            :validate="errors"
            :clear="clear"
          />
        </tab-content>
        <tab-content
          :title="
            $t(
              'school.academic.operation.profile_mgt.parentProfile.childrenInfo'
            )
          "
          icon="fas fa-child"
          :before-change="saveChildrentParent"
        >
          <children
            v-model="childrenModel"
            :validate="childrenErrors"
            :clear="clear"
          />
        </tab-content>
        <tab-content
          :title="
            $t('school.academic.operation.profile_mgt.parentProfile.privacy')
          "
          icon="fas fa-user-lock"
          :before-change="savePrivacy"
        >
          <privacy
            v-model="privacyModel"
            :validate="privacyErrors"
            :clear="clear"
          />
        </tab-content>
        <tab-content
          :title="
            $t('school.academic.operation.profile_mgt.parentProfile.agreement')
          "
          icon="fas fa-file-signature"
        >
          <agreement
            v-model="agreementModel"
            :validate="agreementErrors"
            :clear="clear"
          />
        </tab-content>

        <template slot="footer" slot-scope="props">
          <div class="wizard-footer-left">
            <wizard-button
              v-if="props.activeTabIndex > 0 && !props.isLastStep"
              @click.native="props.prevTab()"
              :style="'background:#e2e2e2'"
              >{{
                $t(
                  'school.academic.operation.profile_mgt.parentProfile.previous'
                )
              }}</wizard-button
            >
          </div>
          <div class="wizard-footer-right">
            <wizard-button
              v-if="!props.isLastStep"
              @click.native="props.nextTab()"
              class="wizard-footer-right"
              :style="props.fillButtonStyle"
              :disabled="nextStep"
            >
              <i class="fa fa-spinner spin mr-2" v-if="nextStep"></i>
              {{
                $t('school.academic.operation.profile_mgt.parentProfile.next')
              }}
            </wizard-button>
            <wizard-button
              v-else
              @click.native="onComplete"
              class="wizard-footer-right finish-button"
              :style="props.fillButtonStyle"
              :disabled="nextStep"
            >
              <i class="fa fa-spinner spin mr-2" v-if="nextStep"></i>
              {{
                props.isLastStep
                  ? $t(
                      'school.academic.operation.profile_mgt.parentProfile.done'
                    )
                  : $t(
                      'school.academic.operation.profile_mgt.parentProfile.next'
                    )
              }}
            </wizard-button>
          </div>
        </template>
      </form-wizard>
      <!-- </ts-card-wrapper> -->
    </ts-card>
  </div>
</template>

<script>
import { FormWizard, TabContent, WizardButton } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'

import Father from './component/father'
import Mother from './component/mother'
import Children from './component/children'
import Privacy from './component/privacy'
import AddressComponent from './component/address'
import Agreement from './component/agreement'

export default {
  name: 'parentProfileEdit',
  components: {
    FormWizard,
    TabContent,
    WizardButton,
    Father,
    Mother,
    Children,
    Privacy,
    AddressComponent,
    Agreement
  },
  data() {
    return {
      model: {
        student_parent_id: 0,
        father_name_kh: '',
        father_name_en: '',
        father_nationality_id: '',
        father_religion: '',
        father_dob: '',
        father_occupation_id: '',
        father_photo: '',
        father_phone1: '',
        father_phone2: '',
        father_emails: '',
        father_facebook: '',
        father_linked_in: '',
        father_telegram: '',
        father_line: '',
        father_wechat: '',
        father_sms: false,
        father_email: false,
        mother_name_kh: '',
        mother_name_en: '',
        mother_nationality_id: '',
        mother_religion: '',
        mother_dob: '',
        mother_occupation_id: '',
        mother_photo: '',
        mother_phone1: '',
        mother_phone2: '',
        mother_emails: '',
        mother_facebook: '',
        mother_linked_in: '',
        mother_telegram: '',
        mother_line: '',
        mother_wechat: '',
        mother_sms: false,
        mother_email: false,
        province_code: '',
        district_code: '',
        commune_code: '',
        village_code: '',
        street: '',
        house_no: '',
        mi_range_spare1: false,
        mi_range_spare2: false,
        mi_range_spare3: false,
        mi_range_spare4: false,
        mi_range_spare5: false,
        mi_range_spare6: false,
        father_login: true,
        mother_login: true,
        father_login_name: '',
        mother_login_name: '',
        father_allow_pickup: true,
        mother_allow_pickup: true
      },
      childrenModel: {
        student_parent_id: '',
        children_list: []
      },
      privacyModel: {
        student_parent_id: '',
        not_type_list: []
      },
      agreementModel: {
        student_parent_id: '',
        agreement_cat_id: '',
        agreement_attached_file: '',
        agreement_display_name: '',
        is_agreed: false,
        file: ''
      },
      errors: new Errors(),
      childrenErrors: new Errors(),
      privacyErrors: new Errors(),
      agreementErrors: new Errors(),
      nextStep: false,
      continueNextStep: false,
      clear: false
    }
  },
  computed: {
    ...mapState('parentProfile', ['edit_data'])
  },
  methods: {
    ...mapActions('parentProfile', [
      'uploadParentPhoto',
      'store',
      'update',
      'children',
      'privacy',
      'saveAgreement',
      'requestValidateFather',
      'requestValidateMother'
    ]),
    async validateStep(name) {
      var refToValidate = this.$refs[name]
      let validate = refToValidate.validateForm()
      switch (name) {
        case 'father':
          if (validate) {
            await this.fatherTapValidate()
            return this.continueNextStep
          }
          return validate
        case 'mother':
          if (validate) {
            await this.motherTapValidate()
            return this.continueNextStep
          }
          return validate
        default:
          return validate
      }
    },
    async onComplete() {
      let formData = new FormData()
      formData.append(
        'student_parent_id',
        this.agreementModel.student_parent_id
      )
      formData.append('agreement_cat_id', this.agreementModel.agreement_cat_id)
      formData.append(
        'agreement_attached_file',
        this.agreementModel.agreement_attached_file
      )
      formData.append(
        'agreement_display_name',
        this.agreementModel.agreement_display_name
      )
      formData.append('is_agreed', this.agreementModel.is_agreed)
      formData.append('file', this.agreementModel.file)
      this.nextStep = true
      await this.saveAgreement(formData)
        .then(response => {
          this.$toasted.success(response.message)
          this.clear = true
          this.$router.push({ name: 'parent-profile' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.agreementErrors = new Errors(error.errors)
        })
      this.nextStep = false
      this.clear = false
    },
    uploadFatherPhoto() {
      if (
        this.model.father_photo instanceof File ||
        this.model.father_photo instanceof Blob
      ) {
        let formData = new FormData()
        formData.append('photo', this.model.father_photo)
        return this.uploadParentPhoto(formData)
      }
      return this.model.father_photo
    },
    uploadMotherPhoto() {
      if (
        this.model.mother_photo instanceof File ||
        this.model.mother_photo instanceof Blob
      ) {
        let formData = new FormData()
        formData.append('photo', this.model.mother_photo)
        return this.uploadParentPhoto(formData)
      }
      return this.model.mother_photo
    },
    async saveParentProfile() {
      this.nextStep = true
      let father_photo_path = await this.uploadFatherPhoto()
      let mother_photo_path = await this.uploadMotherPhoto()
      this.continueNextStep = false
      await this.update({
        id: this.model.student_parent_id,
        data: Object.assign({}, this.model, {
          father_photo: father_photo_path,
          mother_photo: mother_photo_path
        })
      })
        .then(response => {
          this.model.student_parent_id = response.id
          this.setParentId(response.id)
          this.nextStep = true
          this.continueNextStep = true
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
          this.nextStep = false
          this.continueNextStep = false
        })
      this.nextStep = false
      return this.continueNextStep
    },
    async saveChildrentParent() {
      this.nextStep = true
      this.continueNextStep = false
      await this.children(this.childrenModel)
        .then(response => {
          this.nextStep = true
          this.continueNextStep = true
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.childrenErrors = new Errors(error.errors)
          this.nextStep = false
          this.continueNextStep = false
        })
      this.nextStep = false
      return this.continueNextStep
    },
    async savePrivacy() {
      this.nextStep = true
      this.continueNextStep = false
      await this.privacy(this.privacyModel)
        .then(response => {
          this.nextStep = true
          this.continueNextStep = true
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.privacyErrors = new Errors(error.errors)
          this.nextStep = false
          this.continueNextStep = false
        })
      this.nextStep = false
      return this.continueNextStep
    },
    setParentId(id) {
      if (id) {
        this.childrenModel.student_parent_id = parseInt(id)
        this.privacyModel.student_parent_id = parseInt(id)
        this.agreementModel.student_parent_id = parseInt(id)
      }
    },
    async fatherTapValidate() {
      this.nextStep = true
      return await this.requestValidateFather(this.model)
        .then(() => {
          this.continueNextStep = true
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
          this.nextStep = false
          this.continueNextStep = false
        })
        .finally(() => (this.nextStep = false))
    },
    async motherTapValidate() {
      this.nextStep = true
      return await this.requestValidateMother(this.model)
        .then(() => {
          this.continueNextStep = true
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
          this.nextStep = false
          this.continueNextStep = false
        })
        .finally(() => (this.nextStep = false))
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('parentProfile/RESET_STATE')
    this.$store.commit('parentProfile/SET_EDIT_DATA', {})
    next()
  }
}
</script>

<style lang="css" scoped>
.vue-form-wizard > .wizard-header {
  padding: 6px !important;
}
</style>
